<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="studiesForm">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="estudio.institucion"
                rounded
                filled
                dense
                background-color="primary"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Institución o escuela <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="generacionInicio"
                maxlength="4"
                rounded
                filled
                dense
                background-color="primary"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Año de inicio <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="generacionFin"
                maxlength="4"
                rounded
                filled
                dense
                background-color="primary"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Año de finalización <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                background-color="primary"
                color="secondary"
                rounded
                filled
                dense
                :items="estatusEstudios"
                item-value="id"
                item-text="title"
                v-model="estudio.fk_idCatEstatusEstudio"
                :rules="required"
              >
                <template v-slot:label>Estatus de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                background-color="primary"
                color="secondary"
                rounded
                filled
                dense
                :items="tipoEstudios"
                item-value="id"
                item-text="title"
                v-model="estudio.fk_idCatEstudio"
                :rules="required"
              >
                <template v-slot:label>Tipo de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                background-color="primary"
                color="secondary"
                rounded
                filled
                dense
                :items="comprobanteEstudios"
                item-value="id"
                item-text="title"
                v-model="estudio.fk_idComprobanteEstudio"
                :rules="required"
              >
                <template v-slot:label> Tipo de comprobante de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                no-resize
                rows="4"
                color="secondary"
                background-color="primary"
                label="Observaciones (Opcional)"
                v-model="estudio.observaciones"
                rounded
                filled
                dense
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton :loading="loading" :disabled="!studiesForm || loading" @click="guardarCambios">
        Guardar cambios
      </TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TextButton from '@src/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },

  data() {
    return {
      studiesForm: false,
      loading: false,
      generacionInicio: '',
      generacionFin: '',
      estudio: {
        idEstudioPersonal: null,
        fk_idPersonal: null,
        institucion: '',
        generacion: '',
        observaciones: '',
        fk_idCatEstatusEstudio: null,
        fk_idCatEstudio: null,
        fk_idComprobanteEstudio: null,
      },
      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('comprobanteEstudios', {
      comprobanteEstudios: 'getComprobantesEstudios',
    }),
    ...mapGetters('estatusEstudios', {
      estatusEstudios: 'getEstatusEstudios',
    }),
    ...mapGetters('estudio', {
      tipoEstudios: 'getTipoEstudios',
      selectedEstudio: 'getSelectedEstudio',
    }),
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
  },

  methods: {
    ...mapActions('estudio', ['updateEstudiosPersonal', 'fetchEstudiosByPersonal', 'fetchTipoEstudios']),
    ...mapActions('comprobanteEstudios', ['fetchComprobantesEstudios']),
    ...mapActions('estatusEstudios', ['fetchEstatusEstudios']),

    async guardarCambios() {
      if (!this.estudio.idEstudioPersonal) {
        console.error('Error: ID del estudio no encontrado')
        return
      }

      this.loading = true
      try {
        const payload = {
          id: this.estudio.idEstudioPersonal,
          fk_idPersonal: this.estudio.fk_idPersonal,
          institucion: this.estudio.institucion,
          generacion: this.generacionInicio + '-' + this.generacionFin,
          observaciones: this.estudio.observaciones,
          fk_idCatEstatusEstudio: this.estudio.fk_idCatEstatusEstudio,
          fk_idCatEstudio: this.estudio.fk_idCatEstudio,
          fk_idComprobanteEstudio: this.estudio.fk_idComprobanteEstudio,
        }

        await this.updateEstudiosPersonal(payload)
        await this.fetchEstudiosByPersonal(this.estudio.fk_idPersonal)
        this.$emit('close')
      } catch (e) {
        console.error('Error al guardar cambios:', e)
      } finally {
        this.loading = false
      }
    },
  },

  async created() {
    await this.fetchComprobantesEstudios()
    await this.fetchEstatusEstudios()
    await this.fetchTipoEstudios()

    if (this.selectedEstudio) {
      this.estudio = {
        idEstudioPersonal: this.selectedEstudio.idEstudioPersonal,
        fk_idPersonal: this.selectedEstudio.fk_idPersonal,
        institucion: this.selectedEstudio.institucion,
        generacion: this.selectedEstudio.generacion,
        observaciones: this.selectedEstudio.observaciones,
        fk_idCatEstatusEstudio: this.selectedEstudio.fk_idCatEstatusEstudio,
        fk_idCatEstudio: this.selectedEstudio.fk_idCatEstudio,
        fk_idComprobanteEstudio: this.selectedEstudio.fk_idComprobanteEstudio,
      }

      if (this.estudio.generacion) {
        const [inicio, fin] = this.estudio.generacion.split('-')
        this.generacionInicio = inicio || ''
        this.generacionFin = fin || ''
      }
    }
  },
}
</script>

<style scoped>
/* Text fields dinámicos */
::v-deep .v-text-field .v-input__control .v-input__slot {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

::v-deep .v-text-field.v-input--is-focused .v-input__control .v-input__slot::after {
  border-color: var(--v-secondary-base) !important;
}

::v-deep .v-text-field .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

::v-deep .v-text-field.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-text-field input {
  caret-color: var(--v-secondary-base) !important;
}

/* Select dinámico */
::v-deep .v-select.v-input--is-focused .v-input__control .v-input__slot::after {
  border-color: var(--v-secondary-base) !important;
}

::v-deep .v-select .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

::v-deep .v-select.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-select .v-input__icon--append .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}

::v-deep .v-select.v-input--is-focused .v-input__icon--append .v-icon {
  color: var(--v-secondary-base) !important;
}

/* File input dinámico */
::v-deep .v-file-input.v-input--is-focused .v-input__control .v-input__slot::after {
  border-color: var(--v-secondary-base) !important;
}

::v-deep .v-file-input .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

::v-deep .v-file-input.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-file-input .v-input__icon--prepend-inner .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}

::v-deep .v-file-input.v-input--is-focused .v-input__icon--prepend-inner .v-icon {
  color: var(--v-secondary-base) !important;
}

/* Textarea dinámico */
::v-deep .v-textarea.v-input--is-focused .v-input__control .v-input__slot::after {
  border-color: var(--v-secondary-base) !important;
}

::v-deep .v-textarea .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

::v-deep .v-textarea.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-textarea textarea {
  caret-color: var(--v-secondary-base) !important;
}
</style>
